import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SuppressRelationships
    from '../../../../components/Erm/Actions/FlaggedRelationshipsActions/SuppressRelationships';
import { deleteFlaggedRelationships } from '../../../../store/Erm/FlaggedRelationship/actionCreators';
import { setCloseGlobalModal } from '../../../../store/GlobalModal/actionCreators';

const mapStateToProps = (state: any, ownProps: any) => {
    const modal = state.globalModal;
    return {
        payload: modal && modal.payload ? modal.payload : {},
    };

};

const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators(
        {
            deleteFlaggedRelationships,
            closeModal: () => {
                return setCloseGlobalModal();
            },
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(SuppressRelationships);
